import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Tooltip,
} from "@material-ui/core";
import { Delete } from "@material-ui/icons";
import { Autocomplete } from "@material-ui/lab";
import React, { useEffect, useState } from "react";
import { shallowEqual, useSelector } from "react-redux";
import { CardBody } from "../../../_metronic/_partials/controls";
import { postPartida } from "../../../api/partida";
import { getPartidaCategories } from "../../../api/partidaCategory";
import { getProducts } from "../../../api/product";
import { getProductFamilies } from "../../../api/productFamily";
import { getProductTypes } from "../../../api/productType";
import { getProductUnitTypes } from "../../../api/productUnitType";
import { alertError, alertSuccess } from "../../../utils/logger";
import ProductContent from "../../modules/ContentManager/products/ProductContent";
import Editor from "../editor/Editor";
import Table, { buttonsStyle } from "../tables/table";
import EntityInfoDialog from "./EntityInfoDialog";
import ProductSelectTableDialog from "./ProductSelectTableDialog";
import { getProductMarcas } from "../../../api/productMarca";

function getEmptyPartida() {
  return {
    referencia: null,
    descripcion: null,
    categoria_id: null,
    concepto: null,
    productos: [],
  };
}

function getProductData(partidaProducts, products) {
  let data = [];

  for (let i = 0; i < partidaProducts.length; ++i) {
    const elem = {};

    const partidaProduct = partidaProducts[i];

    const product = products.find((x) => x?.id === partidaProduct?.producto_id);

    elem.tipoUnidad = product?.tipo_unidad?.descripcion;
    elem.referencia = product?.referencia;
    elem.descripcion = product?.descripcion;
    elem.marca = product?.marca?.nombre;
    elem.familia = product?.familia?.descripcion;
    elem.tipoProducto = product?.tipo_producto?.descripcion;
    elem.precio = product?.precio + " €";
    elem.unidades = partidaProduct?.unidades;
    elem.id = product?.id;

    data = data.concat(elem);
  }
  return data;
}

const CreatePartidaDialog = (props) => {
  const { title, open, setOpen, onSave } = props;

  const [partida, setPartida] = useState(getEmptyPartida());

  const [categories, setCategories] = useState([]);
  const [products, setProducts] = useState([]);
  const [productFamilies, setProductFamilies] = useState([]);
  const [productMarcas, setProductMarcas] = useState([]);
  const [productTypes, setProductTypes] = useState([]);
  const [productUnitTypes, setProductUnitTypes] = useState([]);

  const [openConfirmDialog, setOpenConfirmDialog] = useState(false);
  const [openProductTableDialog, setOpenProductTableDialog] = useState(false);
  const [openProductInfoDialog, setOpenProductInfoDialog] = useState(null);

  const [selectedProduct, setSelectedProduct] = useState(null);
  const [refresh, setRefresh] = useState(false);

  const loggedUser = useSelector(
    (store) => store.authentication?.user,
    shallowEqual
  );

  useEffect(() => {
    getProductMarcas(loggedUser?.accessToken)
      .then((res) => {
        if (res.status === 200) {
          setProductMarcas(res.data);
        }
      })
      .catch((error) => {
        alertError({
          error: error,
          customMessage: "No se han podido obtener las marcas de productos.",
        });
      });
    getProductFamilies(loggedUser?.accessToken)
      .then((res) => {
        if (res.status === 200) {
          setProductFamilies(res.data);
        }
      })
      .catch((error) => {
        alertError({
          error: error,
          customMessage: "No se han podido obtener las familias de productos.",
        });
      });
    getProductTypes(loggedUser?.accessToken)
      .then((res) => {
        if (res.status === 200) {
          setProductTypes(res.data);
        }
      })
      .catch((error) => {
        alertError({
          error: error,
          customMessage: "No se han podido obtener los tipos de productos.",
        });
      });
    getPartidaCategories(loggedUser?.accessToken)
      .then((res) => {
        if (res.status === 200) {
          setCategories(res.data);
        }
      })
      .catch((error) => {
        alertError({
          error: error,
          customMessage: "No se han podido obtener las categorías.",
        });
        setOpen(false);
      });
    getProductUnitTypes(loggedUser?.accessToken)
      .then((res) => {
        if (res.status === 200) {
          setProductUnitTypes(res.data);
        }
      })
      .catch((error) => {
        alertError({
          error: error,
          customMessage: "No se han podido obtener los tipos de unidades.",
        });
      });
    getProducts(loggedUser?.accessToken)
      .then((res) => {
        if (res.status === 200) {
          setProducts(res.data);
        }
      })
      .catch((error) => {
        alertError({
          error: error,
          customMessage: "No se han podido obtener los productos.",
        });
        setOpen(false);
      });
  }, []);

  useEffect(() => {
    setRefresh(false);
  }, [refresh]);

  function savePartida() {
    const validatePartida = () => {
      let error = "";

      if (!partida?.descripcion) {
        error = "La descripción es obligatoria.";
      } else if (!partida?.referencia) {
        error = "La referencia es obligatoria.";
      } else if (!partida?.categoria_id) {
        error = "La categoría es obligatoria.";
      } else if (!partida?.concepto) {
        error = "El concepto es obligatorio.";
      } else if (partida?.productos?.some((x) => !x.unidades)) {
        error = "Todos los productos deben tener unidades.";
      }

      if (error) {
        alertError({
          error: error,
        });
        return false;
      }

      return true;
    };

    if (!validatePartida()) {
      return;
    }

    postPartida(partida, loggedUser?.accessToken)
      .then((res) => {
        if (res.status === 201) {
          alertSuccess({
            title: "¡Guardada!",
            customMessage: "Partida guardada con éxito.",
          });
          setOpen(false);
          onSave(res.data?.id);
        }
      })
      .catch((error) => {
        alertError({
          error: error,
          customMessage: "No se ha podido guardar la partida.",
        });
      });
  }

  const handleChange = (element) => (event) => {
    setPartida({ ...partida, [element]: event.target.value });
  };

  const handleChangeEditor = (element, value) => {
    if (value?.trim() !== "") {
      setPartida({ ...partida, [element]: value });
    }
  };

  function buttonFormatter(productId) {
    return (
      <>
        <Tooltip title="Eliminar">
          <Button
            style={buttonsStyle}
            size="small"
            onClick={(e) => {
              e.stopPropagation();
              let products = [...partida.productos];

              products = products?.filter((x) => x?.producto_id !== productId);

              setPartida({ ...partida, productos: products });

              setRefresh(true);
            }}
          >
            <Delete />
          </Button>
        </Tooltip>
      </>
    );
  }

  function unidadesFormatter(productId) {
    const partidaProduct = partida?.productos?.find(
      (x) => x.producto_id === productId
    );

    return (
      <input
        style={{ width: "100%" }}
        type="number"
        min={0}
        value={partidaProduct?.unidades}
        onClick={(e) => e.stopPropagation()}
        onChange={(e) => {
          let _products = [...partida?.productos];

          const productIndex = _products.findIndex(
            (x) => x.producto_id === productId
          );

          if (productIndex !== -1) {
            _products[productIndex] = {
              ..._products[productIndex],
              unidades: Number(e.target.value),
            };
          }

          setPartida({ ...partida, productos: _products });
        }}
        onKeyDown={(e) => {
          if (e.key === "Enter") {
            e.target.blur();
          }
        }}
        onBlur={() => {
          setRefresh(true);
        }}
      />
    );
  }

  const columns = [
    { dataField: "tipoUnidad", text: "Tipo Unidad", sort: true },
    {
      dataField: "referencia",
      text: "Referencia",
      sort: true,
      headerAlign: "center",
      align: "center",
    },
    {
      dataField: "descripcion",
      text: "Descripción",
      sort: true,
      headerAlign: "center",
      align: "center",
    },
    {
      dataField: "marca",
      text: "Marca",
      sort: true,
      headerAlign: "center",
      align: "center",
    },
    {
      dataField: "familia",
      text: "Família",
      sort: true,
      headerAlign: "center",
      align: "center",
    },
    {
      dataField: "tipoProducto",
      text: "Tipo",
      sort: true,
      headerAlign: "center",
      align: "center",
    },
    {
      dataField: "precio",
      text: "Precio",
      sort: true,
      headerAlign: "center",
      align: "center",
    },
    {
      dataField: "id",
      text: "Unidades",
      sort: true,
      headerAlign: "center",
      align: "center",
      formatter: unidadesFormatter,
    },
    { dataField: "id", text: "", formatter: buttonFormatter },
  ];

  return (
    <>
      <Dialog
        fullWidth={true}
        maxWidth="lg"
        open={open}
        onClose={() => {
          setOpen(false);
        }}
        aria-labelledby="table-dialog"
        className="backdrop"
      >
        <DialogTitle id="table-dialog">{"Nueva partida"}</DialogTitle>
        <DialogContent>
          <TextField
            id={`descripcion`}
            label="Descripción"
            value={partida.descripcion}
            onChange={handleChange("descripcion")}
            InputLabelProps={{
              shrink: true,
            }}
            margin="normal"
            variant="outlined"
            required
          />
          <div className="row d-flex align-items-center">
            <div className="col-md-6">
              <TextField
                id={`referencia`}
                label="Referencia"
                value={partida.referencia}
                onChange={handleChange("referencia")}
                InputLabelProps={{
                  shrink: true,
                }}
                margin="normal"
                variant="outlined"
                required
              />
            </div>
            <div className="col-md-6">
              <Autocomplete
                id="autocomplete-categoria"
                disablePortal
                disableClearable
                filterSelectedOptions
                options={categories}
                getOptionLabel={(option) => option.descripcion}
                value={
                  categories?.find((x) => x.id === partida?.categoria_id) || ""
                }
                onChange={(event, selected) => {
                  setPartida({
                    ...partida,
                    categoria_id: selected ? selected.id : null,
                  });
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Categoría"
                    margin="normal"
                    variant="outlined"
                    InputLabelProps={{
                      shrink: true,
                    }}
                    required
                  />
                )}
              />
            </div>
          </div>
          <br />
          <Editor
            body={partida?.concepto || ""}
            setBody={(new_body) => {
              handleChangeEditor("concepto", new_body);
            }}
            className="max-height"
            placeholder={"Introduce el concepto aquí..."}
          />
          <br />
          <div className="d-flex justify-content-between">
            <h4>{"Descompuesto"}</h4>
            <button
              type="button"
              className="btn btn-primary"
              onClick={() => {
                setOpenProductTableDialog(true);
              }}
            >
              Añadir productos
            </button>
          </div>
          {partida.productos?.length > 0 ? (
            <>
              {!refresh && (
                <Table
                  data={getProductData(partida.productos, products)}
                  columns={columns}
                  rowEvents={{
                    onClick: (e, row, rowIndex) => {
                      const product = products?.find((x) => x.id === row.id);
                      setSelectedProduct(product);
                      setOpenProductInfoDialog(true);
                    },
                  }}
                />
              )}
            </>
          ) : (
            <div>Añada productos para gestionar el descompuesto</div>
          )}
        </DialogContent>
        <DialogActions>
          <Button
            className="mr-2"
            onClick={() => {
              setOpen(false);
              setPartida(getEmptyPartida());
            }}
            variant="outlined"
          >
            Cancelar
          </Button>
          <Button
            onClick={() => {
              savePartida();
            }}
            variant="outlined"
            color="primary"
          >
            Guardar
          </Button>
          <br />
        </DialogActions>
      </Dialog>
      <ProductSelectTableDialog
        title="Productos"
        open={openProductTableDialog}
        setOpen={setOpenProductTableDialog}
        data={products?.filter(
          (x) => ![...partida.productos]?.some((y) => y?.producto_id === x?.id)
        )}
        productMarcas={productMarcas}
        productFamilies={productFamilies}
        productTypes={productTypes}
        productUnitTypes={productUnitTypes}
        initialSelectedProducts={[...partida.productos]?.map(
          (x) => x?.producto_id
        )}
        onSave={(selectedProductIds) => {
          let _products;

          if (!Array.isArray(selectedProductIds)) {
            _products = [
              ...partida.productos,
              {
                producto_id: selectedProductIds,
                unidades: 0,
              },
            ];

            if (!products?.some((x) => x.id === selectedProductIds)) {
              getProducts(loggedUser?.accessToken)
                .then((res) => {
                  setProducts(res.data);
                })
                .catch(() => {});
            }
          } else {
            _products = selectedProductIds.map((productId) => {
              const existingProduct = partida.productos.find(
                (x) => x.producto_id === productId
              );

              return {
                producto_id: productId,
                unidades: existingProduct ? existingProduct.unidades : 0,
              };
            });
          }

          setPartida({
            ...partida,
            productos: _products,
          });
        }}
      />
      <EntityInfoDialog
        title={"Producto: " + selectedProduct?.descripcion}
        open={openProductInfoDialog}
        setOpen={setOpenProductInfoDialog}
        content={<ProductContent product={selectedProduct} />}
      />
    </>
  );
};
export default CreatePartidaDialog;
